<template>
  <div :id="element" class="modal fade" role="dialog" tabindex="-1" aria-hidden="true">
    <div :class="`modal-dialog ${modalType}`" :style="modalWidth">
      <div class="modal-content border-0 rounded-2" :style="modalContentMaxHeight">
        <div :class="`modal-header ${headerBackground}`">
          <p :class="`modal-title text-start size-16 fw-bold w-100 ${colorText}`">{{ title }}</p>
          <button
            type="button"
            :class="`btn-close ${btnColseColor}`"
            aria-label="Close"
            data-bs-dismiss="modal"
            @click="onClose"
          ></button>
        </div>
        <div ref="modalBodyElement" class="modal-body p-0 relative" @scroll="checkScroll">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer d-flex justify-content-center rouned-0 flex-column p-0 m-0">
          <div v-if="isShowScrollButton && showDownButton" class="m-0">
            <button class="btn btn-link p-3 m-0" @click="onclick">
              <img src="@/assets/images/icons/arrow-down.svg" />
            </button>
          </div>

          <div v-if="isShowScrollButton && showDownButton" class="border-bottom w-100 m-0"></div>
          <div v-if="!isShowAddButton" class="m-0 p-3">
            <button
              type="button"
              :class="`btn btn-primary btn-primary-icon-plus h-36x w-${submitButtonWidth}x m-0 size-12 lh-12`"
              @click="onAddItems"
            >
              追加する
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { Modal } from 'bootstrap';

const modal = ref<Element | null>(null);
const modalElement = ref();
const modalBodyElement = ref();
const showDownButton = ref(true);

const modalWidth = computed(() => {
  return props.width === 0 ? {} : { maxWidth: props.width + 'px' };
});

const modalContentMaxHeight = computed(() => {
  return window.innerWidth <= 576 ? { maxHeight: 'calc(98vh - 132px)' } : {};
});

const onOpen = (): void => {
  const modalElementDOM: HTMLElement | null = document.getElementById(props.element);
  if (!modalElementDOM) return;
  modalElement.value = new Modal(modalElementDOM);
  modalElement.value.show();
};

const onClose = (): void => {
  modalElement?.value?.hide();
  emits('close');
};

const onAddItems = (): void => {
  emits('addItems');
  onClose();
};

const emits = defineEmits(['addItems', 'close']);

defineExpose({ onOpen, onClose, modal });

const onclick = (): void => {
  if (modalBodyElement.value) {
    modalBodyElement.value.scrollTo({
      top: modalBodyElement.value.scrollTop + 500,
      behavior: 'smooth',
    });
  }
};

watch(
  () => modalElement.value,
  async () => {
    setTimeout(() => {
      checkScroll();
    }, 200);
  }
);

const checkScroll = (): void => {
  if (modalBodyElement.value) {
    const scrollTop = modalBodyElement.value.scrollTop;
    const scrollHeight = modalBodyElement.value.scrollHeight;
    const clientHeight = modalBodyElement.value.clientHeight;

    const isAtBottom = scrollTop + clientHeight >= scrollHeight;
    showDownButton.value = !isAtBottom;
  }
};

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  element: {
    type: String,
    default: '',
  },
  isShowScrollButton: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Number,
    default: false,
  },
  modalType: {
    type: String,
    default: 'modal-lg',
  },
  submitButtonWidth: {
    type: Number,
    default: 184,
  },
  width: {
    type: Number,
    default: 0,
  },
  isShowAddButton: {
    type: Boolean,
    defautl: false,
  },
  headerBackground: {
    type: String,
    default: '',
  },
  btnColseColor: {
    type: String,
    default: '',
  },
  colorText: {
    type: String,
    default: '',
  },
});
</script>
